<script setup lang="ts">
defineProps<{
  active?: boolean;
  icon?: string;
  label: string;
  size?: "small" | "medium" | "large";
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    class="dr-toggle-button"
    :class="[{ active }, `size-${size || 'medium'}`]"
    @click="emit('click')"
  >
    <i v-if="icon" :class="icon" class="icon"></i>
    <span class="label">{{ label }}</span>
  </button>
</template>

<style scoped lang="scss">
.dr-toggle-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  background-color: transparent;
  color: var(--bs-body-color);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background-color: var(--bs-secondary-bg);
  }

  &:active {
    transform: scale(0.98);
  }

  &.active {
    background-color: var(--bs-primary-bg-subtle);
    color: var(--bs-primary-text-emphasis);
    border: 1px solid var(--bs-primary-border-subtle);

    &:hover {
      background-color: var(--bs-primary-bg-subtle);
      opacity: 0.85;
    }
  }

  .icon {
    font-size: 1rem;
  }

  .label {
    line-height: 1;
  }

  &.size-small {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;

    .icon {
      font-size: 0.875rem;
    }
  }

  &.size-large {
    padding: 0.625rem 1.25rem;
    font-size: 1rem;

    .icon {
      font-size: 1.125rem;
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
